(function() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-revealed');
      } else {
        entry.target.classList.remove('scroll-revealed');
      }
    });
  }, { threshold: 0 });

  setTimeout(() => {
    document.querySelectorAll('.text-block--ARjRIZVNUZ1FIbVFNN__text_WbmfQ7')
      .forEach(el => observer.observe(el));
  }, 500);
})();
